import { trackGAToGSNTV } from "./gsntv";

export const track = analytics => {
  const { eventCategory, eventAction, eventLabel, eventValue } = analytics;
  analytics &&
    window.gtag &&
    window.gtag("event", eventAction, {
      event_category: eventCategory,
      event_label: eventLabel,
      value: eventValue
    });
};

export const trackingWrapper = (action, trackingObject={event_category:'split-second-game'}) => {
  
  const { event_category, event_label, label } = trackingObject;

  const data = {action, label, category: event_category, label: event_label};

  trackGAToGSNTV(data);
};